import React from 'react'
import { RegisterItemPropertyFormItemProps } from '@modules/registers/items/form/types'
import { Box, Flex } from '@fundamentals'
import moment from 'moment/moment'
import { Controller, useFormContext } from 'react-hook-form'
import { TimePicker } from '@common/material/TimePicker'

export const RegisterItemTimePropertyFormItem: React.FC<
  RegisterItemPropertyFormItemProps
> = ({ property, registerItem, sx, disabled }) => {
  const { control } = useFormContext()

  const isDisabled =
    disabled || (!!registerItem && property.lockedAfterCreation)

  return (
    <Box
      sx={{
        '.react-datepicker__input-container input': {
          height: 'auto',
          background: 'none',
          border: 'none!important',
          color: 'inherit!important',
        },
        flexGrow: 1,
      }}
    >
      <Flex alignItems='center'>
        <Controller
          name={`${property.id}`}
          rules={{
            validate: (value) => !!value?.timeValue || !property.required,
          }}
          control={control}
          render={({ field, formState: { errors } }) => (
            <TimePicker
              UTC
              withClearButton
              dataTest={`${property.type}-${property.name}`}
              value={
                field.value?.timeValue
                  ? moment.utc(
                      `${moment().format('YYYY-MM-DD')} ${
                        field.value.timeValue
                      }`,
                      'YYYY-MM-DD HH:mm',
                    )
                  : null
              }
              onChange={(date) =>
                field.onChange({
                  ...property,
                  registerPropertyId: property.id,
                  timeValue: date ? moment.utc(date).format('HH:mm') : '',
                })
              }
              required={property.required}
              error={!!Object.keys(errors).includes(`${property.id}`)}
              disabled={isDisabled}
              sx={{
                mb: 2,
                width: '100%',
                ...sx,
              }}
              label={property.name}
            />
          )}
        />
      </Flex>
    </Box>
  )
}
